import { useSyncExternalStore } from 'react';

/**
 * The window's width, as a render input.
 *
 * The rails clamp against the live viewport (`model/rails.ts`), so the layout
 * has to re-run when the window changes — otherwise a console dragged narrow
 * keeps a 620 px rail over a 40 px centre pane until something else happens to
 * re-render.
 *
 * `useSyncExternalStore` rather than `useState` + an effect: the width is
 * external state that already exists before React mounts, and reading it in a
 * subscription is the one form that cannot render a stale value on the first
 * paint.
 */
function subscribe(onChange: () => void): () => void {
  window.addEventListener('resize', onChange);
  return () => window.removeEventListener('resize', onChange);
}

export function useViewportWidth(): number {
  return useSyncExternalStore(
    subscribe,
    () => window.innerWidth,
    // Server snapshot: there is no SSR here, and the value is only ever a floor
    // for `railLayout`, which clamps against the minimum viewport anyway.
    () => 1920,
  );
}
